import React, { useEffect, useState, FC, useContext } from 'react';
import { useApolloClient } from '@apollo/react-hooks';
// ts
import { IDataContainer } from 'src/@infringementsCandidates/props';
// app state
import { useFilterDataSelectors } from 'src/app/reducers';
import { useSortSelectors } from 'src/@infringementsCandidates/reducers';
// selectors
import { useConfigSelectors } from 'src/app/reducers/configReducer';
import { InfringementDispatchContext } from 'src/@infringementsCandidates/providers/InfringementsStateProvider';
// actions
import {
  /* fetchData, */
  initialiseFilterStore,
  /* resetAndFetchData, */
  resetCandidates,
  fetchNoiseMonitors,
} from 'src/@infringementsCandidates/actions';
// stores
import { filterStore } from 'src/@infringementsCandidates/stores/filterStore';
import { dateRangeStore } from 'src/app/stores/dateRangeStore';
// constants
import { INITIALISE_EVENT } from 'src/constants';

export const DataContainer: FC<IDataContainer> = ({ candidateFlag, children }) => {
  const client = useApolloClient();
  const dispatcher = useContext(InfringementDispatchContext);
  // Configuration
  const configSelectors = useConfigSelectors();
  const sortSelectors = useSortSelectors();
  const sortString = sortSelectors.getSortString();

  const {
    grid: {
      /* resultSize */
    },
  } = configSelectors.getConfig();
  const { from, to } = dateRangeStore.getDatesStrings();

  useEffect(() => {
    const isFilterInitialised = filterStore.getIfStoreInitialised();
    if (isFilterInitialised) {
      /* resetAndFetchData(client, resultSize, dispatcher, sortString, candidateFlag); */
    }
  }, [sortString, from, to]);

  // defaults are initialised to false to ensure data is fetched initially
  const [filterInitialised, setFilterInitialised] = useState(false);
  // TODO: we need to get rid of the old filter stores - this is just a work around to pass the filter data to the legacy store
  const filtersSelectors = useFilterDataSelectors();
  const infringementFilterData = filtersSelectors.getInfringementFilterData();
  const operationFilterData = filtersSelectors.getOperationsFilterData();

  useEffect(() => {
    const handleInitialisation = () => {
      const isFilterInitialised = filterStore.getIfStoreInitialised();
      const defaultsNotInitialised = !filterInitialised;
      // Check if everything is initialised, and then check if it hasn't already been done previously
      // This is done to handle future updates to config, preventing a new fetch data should a store fire an INITIALISE_EVENT call
      // Theoretically, this should only be called once as config updates do not call INITIALISE_EVENT at the moment.
      if (isFilterInitialised && defaultsNotInitialised) {
        setFilterInitialised(isFilterInitialised);
        /* fetchData(client, resultSize, dispatcher, sortString); */
        fetchNoiseMonitors(client, dispatcher, operationFilterData.airportIds);
      }
    };

    filterStore.on(INITIALISE_EVENT, handleInitialisation);
    // Handle any initialisation logic here. Each relevant store should be 'reset' to their initial values unless otherwise told.
    initialiseFilterStore({
      infringementFilterData,
    });
    resetCandidates(dispatcher);

    return () => {
      filterStore.removeListener(INITIALISE_EVENT, handleInitialisation);
    };
  }, []);

  return <>{children}</>;
};
